export default __webpack_public_path__ + "static/media/site.6232124f.svg";